import Typography, { TypographyProps } from '@ixigo/iui/Typography';
import { FC, Fragment } from 'react';
import clsx from 'clsx';
import { FareSummaryProps } from './index.types';

const typographyVariantMap: Record<number, TypographyProps['variant']> = {
    1: 'body-md',
    2: 'body-md',
    3: 'body-sm',
    4: 'body-xs',
};

const FareSummary: FC<FareSummaryProps> = ({ data }) => {
    if (!data.length) return null;

    return data.map((item, index) => {
        const { label, level, hideCurrency, isNegative, separator, value } = item;

        return (
            // eslint-disable-next-line react/no-array-index-key
            <Fragment key={index}>
                <div
                    className={clsx(
                        'flex justify-between items-end gap-20 py-5',
                        (level === 3 || level === 4) && 'text-charcoal-600',
                    )}
                >
                    <Typography variant={typographyVariantMap[level]} fontWeight={level === 1 ? 'medium' : 'normal'}>
                        {label}
                    </Typography>
                    {value !== undefined && (
                        <Typography
                            variant={typographyVariantMap[level]}
                            fontWeight={level === 1 ? 'medium' : 'normal'}
                            className={level === 1 ? 'text-green-500' : ''}
                        >
                            {isNegative && '-'}
                            {!hideCurrency && '₹'}
                            {value}
                        </Typography>
                    )}
                </div>
                {separator && <div className='my-5 w-full h-px bg-charcoal-100' />}
            </Fragment>
        );
    });
};

export default FareSummary;
